var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLgeLogoV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 23,
    viewBox: "0 6 67 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4165 24.8438L39.7209 32.9821C44.5009 37.6665 52.2508 37.6665 57.0308 32.9821C61.8108 28.2977 61.8108 20.7029 57.0308 16.0185C52.2508 11.3341 44.5009 11.3341 39.7209 16.0185L39.1331 16.5945L35.1615 12.7023L35.7493 12.1262C42.7228 5.29223 54.029 5.29223 61.0025 12.1262C67.9759 18.9602 67.9759 30.0404 61.0025 36.8744C54.029 43.7084 42.7228 43.7084 35.7493 36.8744L23.1227 24.5003L27.0906 20.6118L31.4127 24.8475L31.4165 24.8438ZM33.1153 22.492L37.0801 18.6065L33.1084 14.7143L29.1436 18.5998L33.1153 22.492Z",
    fill: "#6d6e72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5116 16.0177L34.9191 24.257L34.922 24.2542L39.1412 28.3889L43.1099 24.4996L30.4833 12.1255C23.5098 5.2915 12.2036 5.2915 5.23011 12.1255C-1.74337 18.9595 -1.74337 30.0396 5.23011 36.8736C12.2036 43.7076 23.5098 43.7076 30.4833 36.8736L31.064 36.3045L27.0924 32.4123L26.5116 32.9814C21.7316 37.6658 13.9818 37.6658 9.20178 32.9814C4.42179 28.297 4.42179 20.7021 9.20178 16.0177C13.9818 11.3334 21.7316 11.3334 26.5116 16.0177ZM29.1454 30.4003L33.1171 34.2925",
    fill: "#a50034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgeLogoV2);
export default __webpack_public_path__ + "static/media/lge_logo_v2.76c04a248e373e2a6931b8ae11ee19e3.svg";
export { ForwardRef as ReactComponent };